var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSlideshow',{staticClass:"block-slideshow",attrs:{"slides":_vm.content.slides.map(function (s) { return s.media; }),"seconds-on-slide":_vm.content.secondsPerSlide,"fullscreen":false}})}
var staticRenderFns = []

export { render, staticRenderFns }